import { Controller, type UseFormReturn } from 'react-hook-form';
import { CareMapprRadioGroup } from '../../../components/Inputs/radioGroup';
import { InfoIcon } from '../../../components/Icons';
import { CareMapprTextField } from '../../../components/Inputs/textField';
import type { DynamicQuestionFormTypes } from './QuestionsSidebar';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import { QuestionnaireTO } from '../../../../lib';

interface QuestionsFormProps {
  form: UseFormReturn<DynamicQuestionFormTypes, any>;
  thisQuestionnaire?: QuestionnaireTO;
}
const QuestionsForm = ({ form, thisQuestionnaire }: QuestionsFormProps) => {
  const { control } = form;
  const { currentQuestionnaire } = useSelector(
    (state: RootState) => state.dataAnnotation,
  );
  const questions =
    thisQuestionnaire?.questions || currentQuestionnaire?.questions || [];

  return (
    <div className="d-flex flex-column gap-2 overflow-y-auto h-75">
      {[...questions]
        .sort(
          (questionA, questionB) =>
            questionA.questionOrder - questionB.questionOrder,
        )
        .map((question) => (
          <Controller
            key={`${question.questionnairesId}-question-${question.id}`}
            name={`${question.questionnairesId}-question-${question.id}`}
            control={control}
            render={({ field }) =>
              question.type === 'radio' ? (
                <CareMapprRadioGroup
                  controlId={`${question.questionnairesId}-question-${question.id}`}
                  options={(question.value || []).map((value) => ({
                    label: value.toString(),
                    value,
                  }))}
                  label={
                    <div className="d-flex align-items-center gap-1 flex-wrap text-wrap">
                      <span className="font-14 roboto font-weight-400">
                        {question.question}
                      </span>
                      <InfoIcon />
                    </div>
                  }
                  selectedValue={field.value}
                  onChange={field.onChange}
                  direction="vertical"
                />
              ) : (
                <CareMapprTextField
                  label={question.question}
                  value={field.value}
                  onChange={field.onChange}
                  labelClassName="font-14 roboto font-weight-400"
                />
              )
            }
          />
        ))}
    </div>
  );
};

export default QuestionsForm;
